import {SignalREvent} from '../../../constants/dataEnum';

export const subscribeEvent = (hubObject) => () => {
  hubObject.on(SignalREvent.HEARTBEAT, (/* args */) => {
    // console.log(SignalREvent.HEARTBEAT, args);
  });
};

export default subscribeEvent;
